/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamSubEvaluationRatingInputDimGrades } from './oralExamSubEvaluationRatingInputDimGrades';
import type { OralExamSubEvaluationRatingInputQuestionFeedback } from './oralExamSubEvaluationRatingInputQuestionFeedback';

/**
 * Per-question rating. question_feedback round-trips via dim_comments[questionId] in DB.
 */
export interface OralExamSubEvaluationRatingInput {
  dimGrades: OralExamSubEvaluationRatingInputDimGrades;
  questionFeedback?: OralExamSubEvaluationRatingInputQuestionFeedback;
}
